import { FunctionComponent } from "react"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import { CartStructure, Product, ShippingMethod } from "../../interfaces/SaleorTypes"
import { calculateSubtotal, getFormattedPrice } from "../../../utils/cart-helpers"
import CheckoutShippingSection from "./CheckoutShippingSection"
import H3 from "../../atoms/typography/H3"
import BodyMedium from "../../atoms/typography/BodyMedium"
import Line from "../../atoms/Line"
import CartSolutionSection from "../../molecules/store/cart/CartSolutionSection"
import { CartSolutionOrder } from "../../../utils/models"
import CartAccessorySection from "../../molecules/store/cart/CartAccessorySection"
import H2 from "../../atoms/typography/H2"

interface CheckoutSummaryProps {
  cart: CartStructure[]
  shippingMethod?: ShippingMethod
  isSummaryLocked: boolean
  isDirectPayment: boolean
  removeFromCart: (products: CartStructure[]) => void
  addToCart: (products: CartStructure[], isEditingDataPlan?: boolean) => void
  updateItemInCart: (item: Product) => void
  onSetModal: (flag: boolean, view: string) => void
  solutions: CartSolutionOrder[]
}

const TotalSummaryContainer = styled.div`
  padding-left: 10%;
  padding-right: 10%;
`

const CheckoutSummary: FunctionComponent<CheckoutSummaryProps> = ({
  cart,
  shippingMethod,
  isSummaryLocked,
  isDirectPayment,
  removeFromCart,
  addToCart,
  updateItemInCart,
  onSetModal,
  solutions,
  ...props
}) => {
  const accessories = cart.filter((item) => item.product.category.name == "Accessories")

  return (
    <div>
      <div>
        <BodyMedium>Terminals</BodyMedium>
        <Line />
        <HorizontalSpacer spacing={1} />

        <CartSolutionSection solutions={solutions} />
      </div>

      {accessories && accessories.length > 0 && (
        <div>
          <BodyMedium>Accessories</BodyMedium>
          <Line />
          <HorizontalSpacer spacing={1} />

          {accessories.map((accessories: CartStructure, index: number) => (
            <CartAccessorySection
              key={`${accessories.product.id} ${index}`}
              accessory={accessories}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
            />
          ))}
        </div>
      )}

      {shippingMethod && <CheckoutShippingSection shippingMethod={shippingMethod} />}

      <TotalSummaryContainer>
        <H3 textAlign="center">Estimated delivery time:</H3>
        <H3 textAlign="center">30 days from order confirmation</H3>
      </TotalSummaryContainer>
      <HorizontalSpacer spacing={0.5} />
      <H2 textAlign="center">
        Total:{" "}
        {isDirectPayment
          ? getFormattedPrice(
              calculateSubtotal(cart, shippingMethod),
              cart[0]?.product.variants[0].pricing.price.currency,
            )
          : "TBD"}
      </H2>
    </div>
  )
}

export default CheckoutSummary
